<template>
  <div class="paid-time-of height_100">
    <div class="pto-header">
      <div style="margin: 15px;">
        <div class="col-md-12">
            <h3>Holiday List {{currentYear}}</h3>
        </div>
        <!-- <div class="col-md-8">
          <a  style="float:right" @click="openFedaralListPopup = true"><b>View Federal Holiday List</b></a>
        </div> -->
        <div v-if="OrganizationHolidaysList && OrganizationHolidaysList.length > 0" class="col-md-12">
          <p>Holiday list displays the list of all the holidays alloted by your organization for the current Fiscal year.</p>
        </div>
      </div>
    </div>
    <div class="pto-body">
      <template  v-if="OrganizationHolidaysList && OrganizationHolidaysList.length > 0">
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-12">
            <ob-table  fixed-body="100%" :table-header="tableHeader1" :table-data="OrganizationHolidaysList" :config="config" ref="maintable">
            </ob-table>
          </div>
        </div>
      </template>
      <template  v-else>
        <div class="col-md-12" style="height: 100%;">
          <div class="MT-Content-table">
            <div class="MT-Content">
              <div style="margin-bottom: 20px;">
                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_noholidays.svg`"/>
              </div>
              <div style="font-size: 14px;">Your organization hasn't allotted any holidays for the current Fiscal Year.</div>
            </div>
          </div>
        </div>
      </template>
      
    </div>
    <!-- <ob-modal2 width="900px" :show.sync="openFedaralListPopup" :backdrop="false">
      <template>
        <template slot="modal-title">
          <b style="color:#51688A">Federal Holiday List {{currentYear}} </b>
        </template>
        <template slot="modal-body">
          <div v-if="federalHolidayList && federalHolidayList.length > 0">
            <ob-table  fixed-body="100%" :table-header="tableHeader" :table-data="federalHolidayList" :config="config" ref="maintable">
            </ob-table>
          </div>
          <div class="MT-Content-table" v-else>
            <div class="MT-Content">
              <b>Your employer hasn't provided any Federal Holidays for this year.</b>
            </div>
          </div>
        </template>
        <template slot="modal-footer">
          <ob-button  type="secondary" @click="onHolidayListClose()">Close</ob-button>
        </template>
      </template>
    </ob-modal2> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      OrganizationHolidaysList:[],
     // openFedaralListPopup : false,
     // federalHolidayList:null,
      Holidays:[],
      config: {
        primaryKey: "Id",
        fixedCols: {
        left: 0,
        right: 0
        }
      },
     tableHeader1: [
        {
          key: "Date",
          name: "Date"
        },
        {
          key: "Title",
          name: "Holiday(s)",
        },
        {
          key: "DayType",
          name: "Type",
          transform: (o) => {
              if (o.DayType != null && o.DayType != '' && o.DayType == "FederalHoliday")
                  return 'Federal Holiday'
              else
                  return o.DayType
          }
        },
         {
          key: "Day",
          name: "Day of the Week"
        }
      ],
      tableHeader: [
        {
          key: "Date",
          name: "Date"
        },
        {
          key: "Title",
          name: "Federal Holiday",
        },
        {
          key: "Day",
          name: "Day of the Week"
        }
      ]
    }
  },
  components:{
  },

  created(){
    this.getOrganizationHolidays()
  },
 // watch:{
  //   openFedaralListPopup(val)
  //   {
  //     if(val)
  //       this.getOrganizationHolidays()
  //   },
  // },
  computed:{
    currentYear()
    {
      return " " + moment().format("YYYY")
    }
  },
  methods: {
    getOrganizationHolidays(){
       this.$loading({'loadingText': 'Loading...'})
      var currentYear = moment().format("YYYY")
      var OrgId = this.loggedInUserObj.orgId
      ajax.get(`/Leave/OrganizationHolidays/${OrgId}/${currentYear}`, {} ,(res) => {
        this.$loading({}).close()
        //var organizationHolidaysList =  res.data;
        var organizationHolidaysList=  res.data.filter(v=>v.Year == currentYear)
       // this.federalHolidayList = federalHolidays
        this.OrganizationHolidaysList = organizationHolidaysList
        let dateArr =[];

        this.OrganizationHolidaysList.forEach(val=>{
            if(val.Date){
              dateArr.push(val.Date)
            }
        })
        let newArrwithOrder = []
        
        dateArr.sort(function(a,b) {
        a = a.split('/').join('');
        b = b.split('/').join('');
        return a.localeCompare(b);  
      });

        let newModifiedList = []
            dateArr.forEach(val=>{
              this.OrganizationHolidaysList.forEach(value=>{
                  if(val == value.Date){
                      newModifiedList.push(value)
                  }
              })
            })
            this.OrganizationHolidaysList = [...newModifiedList]

      })
    },
    // onHolidayListClose()
    // {
    //   this.openFedaralListPopup = false;
    // },
  }
}
</script>
<style lang="scss" scoped>
  .height_100{
    height:100%;
    overflow: hidden;
  }
  .paid-time-of{
    .pto-footer{
      border-top:1.2px solid #ddd;
      display: inline-block;
      width: 100%;
      padding: 0 10px;
    }
    .pto-header{
      display: inline-block;
      width: 100%;
      padding:  0px 10px 10px 0px;
      margin: 0px -5px;
      h3{
      color: #143361;
      font-weight: 600;
      margin: 0;
      padding-bottom: 10px;
      font-size: 15px;
    }
    p{
      font-weight: 600;
    }
  }
  .pto-body{
    height: 78%;
    overflow-x: hidden;
    overflow-y: auto;
    margin: 5px 15px;
    padding: 0 10px;
      p{
        font-weight: 600;
      }
    .form-group {
      margin-left: -16px;
      margin-top: 15px;
      label{
        font-weight: 600;
        font-size: 11px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/HolidayList.vue